import { render } from "./PaperPublication.vue?vue&type=template&id=086dec8a&scoped=true"
import script from "./PaperPublication.vue?vue&type=script&lang=js"
export * from "./PaperPublication.vue?vue&type=script&lang=js"

import "./PaperPublication.vue?vue&type=style&index=0&id=086dec8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-086dec8a"]])

export default __exports__